import React from "react";
import { Navigate } from "react-router-dom";
import useUserStore from "../../store/userStore"; // Import the Zustand store
import useAdminUserStore from "../../store/adminUserStore";

interface AdminRouteProps {
  element: JSX.Element;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ element }) => {
  const isAdminAuth = useAdminUserStore((state) => state.isAdminAuth);
  return isAdminAuth  ? element : <Navigate to="/ad-backdoor" />;
};

export default AdminRoute;
